export default "__VITE_ASSET__CbPTzQiA__"